document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-ts-videos]');
  if (!root) return;

  var main = root.querySelector('[data-ts-videos-main]');
  var player = root.querySelector('[data-ts-videos-player]');
  var mainWrapper = root.querySelector('.amd-ts-videos__wrapper--main');
  var mainOverlay = root.querySelector('[data-ts-videos-main-overlay]');
  var activeTitle = root.querySelector('[data-ts-videos-active-title]');
  var items = root.querySelectorAll('.amd-ts-videos__item');
  var triggers = root.querySelectorAll('[data-ts-videos-trigger]');

  if (!main || !player || !triggers.length) return;

  // Before the visitor presses play, the main video should look exactly like
  // a list thumbnail (poster + centered play icon), not the browser's native
  // poster/controls treatment.
  if (mainWrapper) {
    player.addEventListener('play', function () {
      mainWrapper.classList.add('is-playing');
    });
  }

  if (mainOverlay) {
    mainOverlay.addEventListener('click', function () {
      var playPromise = player.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var videoSrc = trigger.getAttribute('data-video-src');
      var posterSrc = trigger.getAttribute('data-poster-src');
      var title = trigger.getAttribute('data-title');

      items.forEach(function (item) {
        item.classList.remove('amd-ts-videos__item--active');
      });
      var parentItem = trigger.closest('.amd-ts-videos__item');
      if (parentItem) parentItem.classList.add('amd-ts-videos__item--active');

      main.classList.add('is-swapping');

      window.setTimeout(function () {
        var source = player.querySelector('source');
        if (!source) {
          source = document.createElement('source');
          source.type = 'video/mp4';
          player.appendChild(source);
        }
        if (videoSrc) {
          source.src = videoSrc;
        }
        if (posterSrc) {
          player.setAttribute('poster', posterSrc);
        } else {
          player.removeAttribute('poster');
        }
        player.load();

        if (mainOverlay) {
          mainOverlay.style.backgroundImage = posterSrc ? 'url(\'' + posterSrc + '\')' : '';
        }
        if (mainWrapper) {
          mainWrapper.classList.remove('is-playing');
        }

        if (activeTitle && title) {
          activeTitle.textContent = title;
        }

        main.classList.remove('is-swapping');

        var playPromise = player.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }, 400);

      main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
